import { Cryptokey, ddCorpId } from './config'
import CryptoJS from 'crypto-js'
import dd from 'DD'
import { Toast, Dialog } from 'vant'
export function isAndroid () {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isAndroid) {
    return true
  } else if (isIOS) {
    return false
  }
}
export function shareDD ({ title, content = '复星人最【火热】的专属互动、学习、分享社区', url = '', img = 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/xingyanxingyu.png', params }) {
  if (dd.env.platform !== 'notInDingTalk') {
    dd.biz.util.share({
      type: 0, // 分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
      url: `https://ui-circle.fosun.com${url}`,
      title,
      content,
      image: img
    })
  }
}
export function shareDD2 ({ title, content = '复星人最【火热】的专属互动、学习、分享社区', url = '', img = 'https://exerland-bbs.oss-cn-shanghai.aliyuncs.com/xingyanxingyu.png', params }) {
  if (dd.env.platform !== 'notInDingTalk') {
    dd.biz.util.share({
      type: 0, // 分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
      url,
      title,
      content,
      image: img
    })
  }
}
export function getContacts () {
  const corpId = 'ding6f768bca630f8220' // ding7a05491d2e914134
  dd.ready(() => {
    dd.biz.contact.complexPicker({
      title: '测试标题', // 标题
      corpId: corpId, // 企业的corpId
      multiple: true, // 是否多选
      limitTips: '超出了', // 超过限定人数返回提示
      maxUsers: 1000, // 最大可选人数
      pickedUsers: [], // 已选用户
      pickedDepartments: [], // 已选部门
      disabledUsers: [], // 不可选用户
      disabledDepartments: [], // 不可选部门
      requiredUsers: [], // 必选用户（不可取消选中状态）
      requiredDepartments: [], // 必选部门（不可取消选中状态）
      appId: 789340589, // 微应用Id，企业内部应用查看AgentId
      responseUserOnly: true, // 返回人，或者返回人和部门
      startWithDepartmentId: 0, // 仅支持0和-1
      onSuccess: function (result) {
        alert(JSON.stringify(result))
        /**
          {
              selectedCount:1,                              //选择人数
              users:[{"name":"","avatar":"","userid":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
              departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
          }
          */
      },
      onFail: function (err) {
        alert(JSON.stringify(err))
      }
    })
  })
}
export function openSession (corpId = 'ding6f768bca630f8220', userId) {
  dd.biz.chat.toConversation({
    corpId, /// /企业id,必须是用户所属的企业的corpid
    userId, // 会话Id
    onSuccess: function () {},
    onFail: function (Error) {
      // _this.$toast.fail(JSON.stringify(Error))
    }
  })
}
export function setHeadMates ({ title = '星圈', description = '复星人最【火热】的专属互动、学习、分享社区', image = 'https://exerlalnd.oss-cn-shanghai.aliyuncs.com/wechat/logo.png' }) {
  const head = document.head
  const img = head.childNodes[13]
  img.content = image

  const elTitle = head.childNodes[15]
  elTitle.content = title

  const elDesc = head.childNodes[17]
  elDesc.content = description

  // const elImage = document.createElement('meta')
  // elImage.setAttribute('property', 'og:image')
  // elImage.content = image
  // head.append(elImage)

  // const elTtitle = document.createElement('meta')
  // elTtitle.setAttribute('property', 'og:title')
  // elTtitle.content = title
  // head.appendChild(elTtitle)

  // const elDescription = document.createElement('meta')
  // elDescription.setAttribute('property', 'og:description')
  // elDescription.content = description
  // head.appendChild(elDescription)
}

export function isOverflow (el) {
  if (el) {
    return el.scrollHeight - el.clientHeight > 0
  }
  // 获取元素是否在可视区域
  // var rect = el.getBoundingClientRect()
  // console.log(el.scrollHeight, el.clientHeight)
  // return rect.bottom - rect.top > el.clientHeight
}
export function IsURL (url) {
  /* eslint-disable-next-line */
  const regex = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g
  return regex.test(url)
}

export function encrypt (word) {
  const raw = CryptoJS.enc.Utf8.parse(word)
  const key = CryptoJS.enc.Utf8.parse(Cryptokey)
  const encrypted = CryptoJS.AES.encrypt(raw, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
}
export function encryptCMS (word) {
  const raw = CryptoJS.enc.Utf8.parse(word)
  const key = CryptoJS.enc.Utf8.parse(Cryptokey)
  const encrypted = CryptoJS.AES.encrypt(raw, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString()
}
export function decrypt (word) {
  const key = CryptoJS.enc.Utf8.parse(Cryptokey)
  // const encryptedBytes = CryptoJS.enc.Base64.parse(word)
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}
// 压缩图片方法
export function compressImage (file, quality) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    // 读取文件
    reader.readAsDataURL(file)

    // 文件读取完成后触发
    reader.onload = function (event) {
      const image = new Image()

      // 图片加载完成后触发
      image.onload = function () {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')

        // 设置canvas尺寸与图像尺寸一致
        canvas.width = image.width
        canvas.height = image.height

        // 在canvas上绘制图像
        context.drawImage(image, 0, 0)

        // 将canvas转换为Blob对象
        canvas.toBlob(function (blob) {
          // 返回压缩后的二进制文件
          resolve(blob)
        }, 'image/jpeg', quality)
      }

      // 加载图片
      image.src = event.target.result
    }

    // 文件读取错误时触发
    reader.onerror = function (event) {
      reject(event.target.error)
    }
  })
}
// 跳转钉钉个人对话框
export async function openSingleChat (userInfo) {
  // 先判断是否为移动钉钉端
  if (!await isPc() && dd.env.platform !== 'notInDingTalk') {
    Dialog.confirm({
      message: `即将跳转至与 ${userInfo.name} 的钉钉对话框`
    })
      .then(() => {
        // 调用钉钉API
        Toast.loading({
          message: '跳转中...',
          forbidClick: true,
          loadingType: 'spinner'
        })
        dd.ready(function () {
          dd.biz.chat.openSingleChat({
            corpId: ddCorpId, // 企业id,必须是用户所属的企业的corpid
            userId: userInfo.userId, // 用户的工号
            onSuccess: function () {
              // _this.setHelpData()
            },
            onFail: function (Error) {
              Toast.fail('网络繁忙')
            }
          })
        })
      })
      .catch(() => {
        Toast.fail('网络繁忙')
      })
  } else {
    Toast.fail('使用手机钉钉打开跳转')
  }
}
export async function isPc () {
  let isPc = true
  try {
    await dd.device.base.getPhoneInfo({
      onSuccess: function (data) {
        // alert('现在是手机移动端')
        isPc = false
      },
      onFail: function (err) {
        alert(JSON.stringify(err))
      }
    })
  } catch (error) {
    isPc = true
  }
  return isPc
}
